<template>
    <div>
        <h1 class="mb-8 font-bold text-3xl">
            <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('events.index')">Events
            </inertia-link>
            <span class="text-indigo-400 font-medium">/</span>
            <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('events.show', [eventInfo.id])">
                {{ eventInfo.name }}
            </inertia-link>
            <span class="text-indigo-400 font-medium">/</span>
            Import Attendees
        </h1>
        <div class="flex flex-wrap">

            <div class="w-full lg:w-1/2 px-2">
                <form @submit.prevent="submitUploadImport">
                    <card v-if="can.import">
                        <template v-slot:header>Manual Import</template>

                        <div class="p-6 flex flex-wrap">
                            <file-input v-model="form.import_file" :error="form.errors.import_file" class="pb-4 w-full"
                                        type="file" label="Import File"/>
                        </div>

                        <template v-slot:footer>
                            <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Upload
                            </loading-button>
                        </template>
                    </card>
                </form>

                <card v-if="can.import">
                    <template v-slot:header>Auto Import</template>
                    <card-list-item v-for="autoImport in attendeeAutoImports" :key="autoImport.id">
                        {{ autoImport.name }}
                        <loading-button v-if="can.import" :loading="autoImportForm.processing" class="btn-indigo-sm ml-auto" type="button" @click="submitAutoImport(autoImport.id)" title="Check for Updates">
                            <icon name="refresh" class="w-4 h-4 fill-white" />
                        </loading-button>
                        <a v-if="can.auto_import.edit" :href="route('attendee-auto-import.show', [autoImport.id])" class="btn-indigo-sm ml-2" title="Edit">
                            <icon name="pencil" class="w-4 h-4 fill-white" />
                        </a>
                    </card-list-item>
                    <card-list-item v-if="attendeeAutoImports.length === 0">
                        No auto imports found.
                    </card-list-item>

                    <template v-if="can.auto_import.create" v-slot:footer>
                        <a :href="route('attendee-auto-import.create', [eventInfo.id])" class="btn-indigo ml-auto">Add
                            Auto Import</a>
                    </template>
                </card>
            </div>

            <div class="w-full lg:w-1/2 px-2">
                <table-wrapper :headers="['ID', 'Time', 'Status']" :text-wrap="false" class="mb-4">
                    <table-row v-for="batch in attendeeImportBatches" :key="batch.id">
                        <table-cell :href="route('attendee-import.show', [batch.id])">{{ batch.id }}</table-cell>
                        <table-cell :href="route('attendee-import.show', [batch.id])">{{ dateFormat(batch.created_at) }}</table-cell>
                        <table-cell :href="route('attendee-import.show', [batch.id])">{{ statusName(batch.status) }}</table-cell>
                        <table-cell-end :href="route('attendee-import.show', [batch.id])"></table-cell-end>
                    </table-row>

                    <table-row v-if="attendeeImportBatches.length === 0">
                        <table-cell colspan="4">
                            No Import Batches Found
                        </table-cell>
                    </table-row>
                </table-wrapper>
            </div>
        </div>
    </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import Icon from "@/Shared/Icon";
import FileInput from "@/Shared/FileInput";
import LoadingButton from "@/Shared/LoadingButton";
import Badge from "@/Shared/Badge";
import Card from "@/Shared/Card/Card";
import CardListItem from "@/Shared/Card/CardListItem";
import TableWrapper from "@/Shared/Table/TableWrapper"
import TableRow from "@/Shared/Table/TableRow"
import TableCell from "@/Shared/Table/TableCell"
import {DateTime} from "luxon";
import {AttendeeImportBatchStatus} from "@/Enums/Enums";
import {find} from "lodash";
import Pluralize from 'pluralize';
import TableCellEnd from "../../Shared/Table/TableCellEnd.vue";

export default {
    metaInfo: {title: "Attendee Import"},
    components: {
        TableCellEnd,
        Icon,
        FileInput,
        LoadingButton,
        Badge,
        Card,
        CardListItem,
        TableWrapper,
        TableRow,
        TableCell,
    },
    layout: Layout,
    props: {
        eventInfo: Object,
        can: Object,
        attendeeImportBatches: Array,
        attendeeAutoImports: Array,
    },
    data() {
        return {
            form: this.$inertia.form({
                source: 'upload',
                import_file: null,
            }),
            autoImportForm: this.$inertia.form({
                source: 'auto',
                id: null,
            }),

        }
    },
    watch: {},
    methods: {
        submitUploadImport() {
            this.form.transform((data) => ({
                ...data,
                event_id: this.eventInfo.id,
            })).post(this.route('attendee-import.store'))
        },
        submitAutoImport(autoImportId) {
            this.autoImportForm.id = autoImportId

            this.autoImportForm.transform((data) => ({
                ...data,
                event_id: this.eventInfo.id,
            })).post(this.route('attendee-import.store'))
        },
        dateFormat(iso) {
            return DateTime.fromISO(iso).toFormat('dd LLL yyyy HH:mm ZZZZ')
        },
        statusName(status) {
            return find(AttendeeImportBatchStatus, ['value', status])['label']
        },
        Pluralize,
    },
};
</script>
